
import { defineComponent } from 'vue';
import { AppFormRow, AppInput, AppCard, AppSwitch, AppButton, AppFileUpload } from '@/components';
import { useSurpriseItemAdd } from '@/modules/surprise/category/item/model/add';
import { ROUTE_NAME_SURPRISE } from '@/modules/surprise/router';

export default defineComponent({
    name: ROUTE_NAME_SURPRISE.CATEGORY.ITEM.ADD,
    components: { AppFormRow, AppInput, AppCard, AppSwitch, AppButton, AppFileUpload },
    setup() {
        const { model, v$, create } = useSurpriseItemAdd();

        return { v$, model, create };
    }
});
